import { Authenticator } from "@aws-amplify/ui-react";
import Navigation from "../components/Navigation/Navigation";
import Spinner from "../components/Spinner/Spinner";
import "@aws-amplify/ui-react/styles.css";
import Banner from "../components/Banner/Banner";
import Footer from "../components/Footer/Footer";
import PostJobSection from "../components/PostJob/PostJobSection";

function PostJob() {
  return (
    <div className="container-xxl bg-white p-0">
      <Spinner />
      <Navigation />
      <Authenticator>
        {({ signOut, user }) => (
          <>
            <Banner pageName="Post A Job" />
            <div
              className="container-xxl pb-5 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <PostJobSection />
            </div>
          </>
        )}
      </Authenticator>
      <Footer />
    </div>
  );
}

export default PostJob;
